import { RootState } from "@/store/store";
import { liveUsageResourceActionOptionsByVisibilitySelector } from "@/store/live-usage-mgmt/selectors/actions/liveUsageResourceActionOptionsByVisibilitySelector";
import { ResourceType } from "@/services/cloudchipr.api";

export const liveUsageResourceActionOptionsByVisibilityExistsSelector = (
  state: RootState,
  masterGridId: string,
  masterResourceType: ResourceType,
) => {
  const options = liveUsageResourceActionOptionsByVisibilitySelector(
    state,
    masterGridId,
    masterResourceType,
  );

  return !!options?.length;
};
